<script lang="ts">
  import { type AlertContent } from "$lib/elev8Api/contentTypes";

  interface Props {
    content: AlertContent;
  }
  const { content }: Props = $props();

  // Insert zero-width-space break hints after URL/email separators so that
  // long unbreakable strings wrap at "@", ".", "-", "/" instead of mid-word.
  const ZWSP = "\u200B";
  const bodyWithBreakHints = $derived(
    content.body_text?.replace(/([@./\-])/g, `$1${ZWSP}`)
  );
</script>

<article class="alert">
  <div class="text-area">
    <h2 class="title">{content.title_text}</h2>
    <div class="content-body">{bodyWithBreakHints}</div>
  </div>
</article>

<style>
  .text-area {
    color: var(--vc-primary);
    background-color: var(--vc-white);
    height: auto;
    padding: 1rem 0.5rem;
    margin: 1.5rem 1.2rem;
  }

  .title {
    font-size: 1.8rem;
    font-weight: 600;
    line-height: 1.2;
    margin-bottom: 0.3em;
  }

  .content-body {
    font-size: 1.4rem;
    line-height: 1.2;
    overflow-wrap: break-word;
  }
</style>
